import { queryClient } from "@/query-client";
import { queryOptions, useMutation } from "@tanstack/react-query";
import type { CreateGeneratedBomData } from "../../types/generated-bom";
import generatedBomService from "../services/generated-bom-service";

export const generatedBomsQueryOptions = (params: Record<string, unknown> = {}) =>
	queryOptions({
		queryKey: ["generated-boms", params],
		queryFn: () => generatedBomService.list(params),
		staleTime: 1000 * 60 * 5,
	});

export const useGeneratedBomCreateMutation = () =>
	useMutation({
		mutationFn: (data: CreateGeneratedBomData) => generatedBomService.create(data),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["generated-boms"] });
		},
	});

export const useGeneratedBomDeleteMutation = () =>
	useMutation({
		mutationFn: (id: string) => generatedBomService.deleteById(id),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["generated-boms"] });
		},
	});
